import { observable, action, computed, runInAction, decorate } from 'mobx';
import agent from '../api/agent';
import { history } from '../../indexMsal';
import { IUser } from '../models/User'
import { RootStore } from './RootStore';
import authContext from '../api/msalAuth';
import {useMsal} from "@azure/msal-react";
import {AccountInfo, InteractionStatus, IPublicClientApplication} from "@azure/msal-browser";
export default class UserStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
  }
  user: IUser | null = null;

  get isLoggedIn() { return !!this.user }

  getUser = async () => {
    // var token = authContext.getCachedToken(adalConfig.clientId);
    if (!this.user) {
      try {
        const user = await agent.User.current();
        runInAction('getting user', () => {
          this.user = user
          // this.rootStore.commonStore.setToken(accessToken);
        })
        await this.rootStore.requestReviewDocumentQuestionStore.GetDocumentsFromLocalStorage();
        await this.rootStore.requestReviewDocumentQuestionStore.CheckHash();
      } catch (error) {
        throw error;
      }
    }
  }



  HasRoles = (requirments: string[]) => {
    let result = true;
    {
      this.user?.roleIds.map((group, i) => {
        if (requirments.includes(group)) {

          result = true;
        }
      })
    }
    return result;
  }
}

decorate(UserStore, {
  user: observable,
  getUser: action,
  HasRoles: action,
  isLoggedIn: computed
});